import React from 'react'
import { Label, Item, Table } from 'semantic-ui-react'

export default ({ order: { restaurant } }) => {
  const merchantName = restaurant.name
  const branchName = restaurant.branch.name
  const merchantType = restaurant.merchant_type === 'mart' ? 'Mart' : 'F & B'
  const merchantTypeColor = restaurant.merchant_type === 'mart' ? 'green' : 'grey'

  return (
    <Table.Cell>
      <Item.Group style={{ margin: 0 }} divided>
        <Item style={{ cursor: 'pointer', margin: 0, padding: 0 }}>
          <Item.Content>
            <Item.Header style={{ fontSize: 14 }}>{merchantName}</Item.Header>
            <Item.Meta style={{ fontSize: 13 }}>{branchName}</Item.Meta>
          </Item.Content>
        </Item>
        <Label style={{ marginTop: 10 }} color={merchantTypeColor} >{merchantType}</Label>
      </Item.Group>
    </Table.Cell>
  )
}



// WEBPACK FOOTER //
// ./src/containers/orders/guide/components/MerchantCell.js